// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlashMessage_wrapper__AcrBa","is_success":"FlashMessage_is_success__4e7Se","is_error":"FlashMessage_is_error__b_ml0","message":"FlashMessage_message__NXrxg"};